export const facebookSizes = [
  {
    label: "Facebook Profile Picture",
    width: 248,
    height: 248,
    actualWidth: 180,
    actualHeight: 180,
    desc: "Facebook recommends a minimum size of 180 x 180 pixels for its Facebook profile picture size. Keen in mind that your pfp pics will display at 820 x 312 on desktops and 640 x 360 pixels on mobiles. Tip: When using a profile picture maker, use happy and colorful images to grab your audiences attention.",
  },
  {
    label: "Facebook Link Image",
    width: 248,
    height: 130,
    actualWidth: 1200,
    actualHeight: 630,
    desc: "Maximum image size is 8MB or between 600 x 315 and 1200 x 630 pixels. Although, the larger the better for optimum impact. Increase your click-throughs with simple, colorful link images or thumbnails by visually connecting with your audience.",
  },
  {
    label: "Facebook Image Post",
    width: 248,
    height: 130,
    actualWidth: 1200,
    actualHeight: 630,
    desc: "Simply stay within the size guidelines of between 600 x 315 and 1200 x 630 pixels whilst checking your upload rates. Create impact on your Facebook page with colorful post images and get more likes and shares.",
  },
  {
    label: "Facebook Cover Photo",
    width: 248,
    height: 94,
    actualWidth: 820,
    actualHeight: 312,
    desc: "Facebook cover photo size varies between mobile and desktop. The ideal cover photo mobile size is 640 x 360 and the ideal cover photo desktop size for Facebook: 820 x 312 pixels. Get your Facebook page the attention it deserves with an optimized, sharp and appealing facebook cover photo.",
  },
  {
    label: "Facebook Event Image",
    width: 248,
    height: 130,
    actualWidth: 1920,
    actualHeight: 1005,
    desc: "The ideal size is 1920 x 1005 pixels and make it stand out with bright colors to stand out on the white and blue Facebook background. Simple and impactful images can boost your event so your reach even more people.",
  },
  {
    label: "Facebook Group Cover",
    width: 248,
    height: 130,
    actualWidth: 1640,
    actualHeight: 856,
    desc: "Facebook recommends 1640 x 856 pixels. However, watch out for the grey areas as you might want to stay within 1640 x 664. Grab attention instantly with the perfect group cover photo to portray your style and image!",
  },
  {
    label: "Facebook Marketplace",
    width: 248,
    height: 248,
    actualWidth: 1200,
    actualHeight: 1200,
    desc: "Make your ads work for you at the optimum size of 1200 x 1200 pixels. Promote your marketplace with powerful ads that tell people instantly about your product or service and how it can help them.",
  },
  {
    label: "Facebook Instant Articles",
    width: 248,
    height: 248,
    actualWidth: 1200,
    actualHeight: 1200,
    desc: "Make sure you follow the ideal 1200 x 1200 pixel size. Tell your news with Facebook’s Instant Articles that loads your stories 4 times faster than normal mobile web. You can even place ads if you wish.",
  },
  {
    label: "Facebook Highlighted Image",
    width: 248,
    height: 148,
    actualWidth: 1200,
    actualHeight: 717,
    desc: "Make your announcements stand out with recommended 1200 x 717 size and high-quality resolution. Share your amazing milestones or events with highlighted images that call your audience to like and share.",
  },
  {
    label: "Facebook Stories",
    width: 248,
    height: 441,
    actualWidth: 1080,
    actualHeight: 1920,
    desc: "Simply follow the optimal size of 1080 x 1920 pixels. Build engagement and generate more followers by reaching out to more people with your 24h Facebook stories. They are more effective at getting onto your potential audience’s feed.",
  },
  {
    label: "Facebook Right Column",
    width: 248,
    height: 248,
    actualWidth: 1200,
    actualHeight: 1200,
    desc: "Keep to the 1200 x 1200 pixel size. Facebook right column ads for desktop can increase your traffic by building engagement and awareness. You have a larger creative space to work with that increase your views by 29%.",
  },
  {
    label: "Facebook Feed",
    width: 248,
    height: 310,
    actualWidth: 1080,
    actualHeight: 1350,
    desc: "Make sure it fits to 1080 x 1350 pixels. People love stories, and building your content and adding stories to your Facebook feed creates emotional attachment that can boost your brand by 21%.",
  },
];

export const instagramSizes = [
  {
    label: "Instagram Profile Pic Size",
    width: 248,
    height: 248,
    actualWidth: 320,
    actualHeight: 320,
    desc: "Instagram pfp should be 320 x 320 pixels. Although the pfp for Instagram will be downloaded in a square format, Instagram profile pictures are circular. Be sure that any features you would like to concentrate are centered so they don’t become cropped out when using our insta dp.",
  },
  {
    label: "Instagram Square Size",
    width: 248,
    height: 248,
    actualWidth: 1080,
    actualHeight: 1080,
    desc: "An Instagram photo size for Square format is 1080 x 1080 pixels in size. Anytime Instagram compresses the file, it maintains its high quality. While Instagram photo sizes also come in horizontal and vertical formats, square posts on the Instagram user profile grid will always show at a 1:1 ratio.",
  },
  {
    label: "Instagram Landscape Post",
    width: 248,
    height: 130,
    actualWidth: 1080,
    actualHeight: 566,
    desc: "Instagram landscape size is 1080 x 566 pixels. It's minimum resolution: 600 x 315 pixels, with a recommended aspect ratio of 1.91:1. Typically chosen for nature and open-air photographs, the landscape option is an additional publishable size.",
  },
  {
    label: "Instagram Ad Square",
    width: 248,
    height: 248,
    actualWidth: 1080,
    actualHeight: 1080,
    desc: "The Instagram ad square photos should have a 1:1 ratio, and optimized at 1080 x 1080 pixels. Using an incorrectly sized ad on Instagram can have a damaging impact on your campaign.",
  },
  {
    label: "Instagram Portrait Post",
    width: 248,
    height: 310,
    actualWidth: 1080,
    actualHeight: 1350,
    desc: "The preferred resolution is 1080 x 1350 pixels. Its minimum resolution is 600 x 750 pixels, with a advised aspect ratio of 4:5. The portrait will show vertically and will occupy nearly all of the screen.",
  },
  {
    label: "Instagram IGTV Cover",
    width: 248,
    height: 386,
    actualWidth: 420,
    actualHeight: 654,
    desc: "Instagram suggests an aspect ratio of 1:1.55 and a specifications for 420 x 654 pixels. The cover shot appears on a channel's page and inside the IGTV lists, so it's worthwhile getting it the proper dimensions.",
  },
  {
    label: "Instagram Stories",
    width: 248,
    height: 441,
    actualWidth: 1080,
    actualHeight: 1920,
    desc: "Instagram Stories, consist of a minimum aspect ratio of 1.91:1 and a max of 9:16. The most commenly used Instagram ratio is 9:16 with an Instagram image size of 1080 x 1920 pixels.",
  },
  {
    label: "Instagram Reels",
    width: 248,
    height: 441,
    actualWidth: 1080,
    actualHeight: 1920,
    desc: "It is tricky to design and style a Reels cover. We opt for Instagram Reels that are 9:16 (1080 x 1920 pixels) or vertically full screen, that is the identical structure of Instagram Stories.",
  },
  {
    label: "Instagram Ad Landscape",
    width: 248,
    height: 130,
    actualWidth: 1080,
    actualHeight: 566,
    desc: "The appropriate Instagram size for landscape image ad sizes needs to be 1080 x 566 pixels, and include an aspect ratio of 1.9:1. Select the ideal ad size prior to uploading images to optimize your campaign.",
  },
  {
    label: "Instagram Ad Portrait",
    width: 248,
    height: 310,
    actualWidth: 1080,
    actualHeight: 1350,
    desc: "The portrait provides value for your content. Stick to the 1080 pixel wide, and up to 1350 pixels tall. The aspect ratio 4:5 or 8:10 is available as a cropping method.",
  },
  {
    label: "Instagram Post Size",
    width: 248,
    height: 310,
    actualWidth: 1080,
    actualHeight: 1350,
    desc: "Instagram dimensions for your feed will vary depending on the Instagram post size ratio: Landscape: 1080 x 566 pixels Portrait: 1080 x 1350 pixels Square: 1080 x 1080 pixels Supported Instagram ratios: Anywhere between 1.91:1 and 4:5",
  },
  {
    label: "Instagram Thumbnail",
    width: 248,
    height: 248,
    actualWidth: 161,
    actualHeight: 161,
    desc: "Instagram thumbnails are scaled-down versions of the photos from the profile. Thumbnail size is 161 x 161 Pixels. Whether it's a video or an image, Instagram generates a thumbnail image in your user profile",
  },
];

export const linkedinSizes = [
  {
    label: "LinkedIn Logo Size",
    width: 248,
    height: 248,
    actualWidth: 300,
    actualHeight: 300,
    desc: "300 x 300 pixels is the optimal logo dimensions for LinkedIn. Generally, business pages with logo graphics receive six times more visitors than those lacking. The logo even shows up when individuals lookup your company.",
  },
  {
    label: "LinkedIn Profile Picture",
    width: 248,
    height: 248,
    actualWidth: 400,
    actualHeight: 400,
    desc: "The perfect size for your personal LinkedIn pfp is 400 x 400 pixels. Any larger LinkedIn profile picture size is fine, as long as it follows the 1:1 ratio. However, you should not choose images smaller than 400 x 400 pixels.",
  },
  {
    label: "LinkedIn Dynamic Ad",
    width: 248,
    height: 248,
    actualWidth: 100,
    actualHeight: 100,
    desc: "Spotlight ads are a Dynamic Ad format that are customized to every LinkedIn member. Ad description inserted above image: Use up to 70 characters, including spaces. Company image: Minimum image size: 100 x 100 pixels for JPG or PNG.",
  },
  {
    label: "LinkedIn Square Post",
    width: 248,
    height: 248,
    actualWidth: 1200,
    actualHeight: 1200,
    desc: "A square post - whether it's an image or a video needs to be sized at 1200 x 1200 pixels. To get the perfect square post, you'll want image dimensions to be on point.",
  },
  {
    label: "LinkedIn Stories",
    width: 248,
    height: 441,
    actualWidth: 1080,
    actualHeight: 1920,
    desc: "The sizes for LinkedIn stories is equivalent to Instagram stories at 1080 x 1920 pixels. If you don't desire to do a live video story, producing your story in images is the ideal thing to do.",
  },
  {
    label: "LinkedIn Portrait Post",
    width: 248,
    height: 310,
    actualWidth: 1080,
    actualHeight: 1350,
    desc: "For portrait posts, we reccomend 1080 x 1350 pixels, these will appear onsite as a 600 x 749 pixels image. It's important to pay attention to the details in order to manage visuals professionally.",
  },
  {
    label: "LinkedIn Sponsored Content",
    width: 248,
    height: 129,
    actualWidth: 1200,
    actualHeight: 627,
    desc: "A graphic size of 1200 x 627 pixels is advisable. Content with dominant visuals are likely to receive up to 38% better CTR. Include a straightforward CTA.so your audience knows how to act on their interest.",
  },
  {
    label: "LinkedIn Blog Post Link",
    width: 248,
    height: 129,
    actualWidth: 1200,
    actualHeight: 627,
    desc: "To keep the content simple to have a look at, you may need to apply an image that's 1200 x 627 pixels. This is the advised LinkedIn image size for sharing a link in an update.",
  },
  {
    label: "LinkedIn Link Post",
    width: 248,
    height: 129,
    actualWidth: 1200,
    actualHeight: 627,
    desc: "Optimal images for your LinkedIn account's link post image are essential.In order to respect the LinkedIn image sizes, the recommended size for a shared link post image is 1200 x 627 pixels.",
  },
  {
    label: "LinkedIn Life Tab Image",
    width: 248,
    height: 83,
    actualWidth: 1128,
    actualHeight: 376,
    desc: "This tab demands a hero image with the encouraged size being 1128 x 376 pixels. LinkedIn makes it possible for guests to your organization's webpage to toggle between the Overview Tab and Life Tab.",
  },
  {
    label: "LinkedIn Background Photo",
    width: 248,
    height: 62,
    actualWidth: 1584,
    actualHeight: 396,
    desc: "Recommended LinkedIn background photo specifications: less than 8MB, 1584 x 396 pixels. The background image can work for your benefit, as you may come across as someone who pays attention to details.",
  },
  {
    label: "LinkedIn Cover Photo",
    width: 248,
    height: 64,
    actualWidth: 1128,
    actualHeight: 191,
    desc: "Image Specifications for Your LinkedIn Cover photo are ideal at 1128 x 191 pixels. The banner image, or cover photo is positioned beneath the horizontal logo within your primary company page.",
  },
  {
    label: "LinkedIn Business Banner",
    width: 248,
    height: 84,
    actualWidth: 646,
    actualHeight: 220,
    desc: "The dimensions of a LinkedIn Business Hero Image is 646 x 220 pixels at minimum. Allow your business banner to catch the eyes of your prospects! You can make it appealing with a great LinkedIn Business Hero Image.",
  },
];

export const twitterSizes = [
  {
    label: "Twitter Card Image",
    width: 248,
    height: 248,
    actualWidth: 120,
    actualHeight: 120,
    desc: "Minimum size is 120 x 120 pixels for both images and videos. Drive more traffic with Twitter cards and the right image to grab attention. Make sure it’s simple to view and that it makes people want to re-tweet.",
  },
  {
    label: "Twitter Profile Picture Size",
    width: 248,
    height: 248,
    actualWidth: 400,
    actualHeight: 400,
    desc: "Twitter's profile picture size has a maximum of 400 x 400 pixel. The pfp pics size here is small so we recommend to use colors and shapes to make your pfp stand out. Create an appealing Twitter profile picture that people can relate to and will make them want to stay on your page.",
  },
  {
    label: "Twitter Website Card Ad",
    width: 248,
    height: 248,
    actualWidth: 800,
    actualHeight: 800,
    desc: "Simply make sure your ads stand out and mean something to people, all within 800 x 800 pixels. Call your target audience to your site with Twitter website cards. You can even include ads to get even higher engagement.",
  },
  {
    label: "Twitter App Card Ad",
    width: 248,
    height: 248,
    actualWidth: 800,
    actualHeight: 800,
    desc: "Get more users to your app with Twitter App cards and the perfect ad all within 800 x 800 pixels. You job is to design the image or video that visually represents your style and unique product or service.",
  },
  {
    label: "Twitter Carousels",
    width: 248,
    height: 248,
    actualWidth: 800,
    actualHeight: 800,
    desc: "Twitter carousels, which can be linked to your website, need to be 800 x 800 pixels and the rest is up to your creativity. Slideshows, or rotating banners, are a powerful way to showcase your product or services.",
  },
  {
    label: "Twitter Fleets Images",
    width: 248,
    height: 441,
    actualWidth: 1080,
    actualHeight: 1920,
    desc: "Use whatever images work for your brand and make sure that you to stick to 1080 x 1920 pixels. Twitter fleets, or stories in a bubble, only stay for 24h so make sure they’re eye-catching.",
  },
  {
    label: "Twitter Direct Message",
    width: 248,
    height: 130,
    actualWidth: 800,
    actualHeight: 418,
    desc: "Twitter direct messages need to be within 800 x 418 pixels in size, although you can still use multimedia content. They can be a powerful way to remind people of your brand, as well as keeping your audience engaged and updated.",
  },
  {
    label: "Twitter Conversation Card",
    width: 248,
    height: 130,
    actualWidth: 800,
    actualHeight: 418,
    desc: "Make sure Twitter conversation cards are at 800 x 418 pixels. They encourage interaction with your tweet and leverage your followers’ own followers. You can use them to unlock hidden content or simply to create excitement about a product.",
  },
  {
    label: "Twitter Video Thumbnail",
    width: 248,
    height: 140,
    actualWidth: 640,
    actualHeight: 360,
    desc: "The ideal Twitter video thumbnail size is 640 x 360 pixels although the best images are those that your target audience can relate to emotionally. Increase the click rate of your Twitter video by making your thumbnail interesting and enticing.",
  },
  {
    label: "Twitter Banner Size",
    width: 248,
    height: 83,
    actualWidth: 1500,
    actualHeight: 500,
    desc: "The perfect size for your Twitter banners is 1500 x 500 pixels but leave some space at the top and bottom to cater for different devices. Tell your story and grab people’s attention with a visually powerful Twitter header and one-liner.",
  },
  {
    label: "Twitter Post Image",
    width: 248,
    height: 140,
    actualWidth: 1200,
    actualHeight: 675,
    desc: "Promote your brand and stand out from the crowd with colorful Twitter post images with ideal size of 1200 x 675 pixels. You can even now also post 4 images in a collage if that’s going to boost your brand.",
  },
];

export const googleAdsSizes = [
  {
    label: "Google Display Square",
    width: 248,
    height: 248,
    actualWidth: 250,
    actualHeight: 250,
    desc: "Google Display square, sized at 250 x 250 pixels, is small and easily adaptable into small spaces. Simply arrange any images and text to be as visible as possible such that your message stands out clearly.",
  },
  {
    label: "Google Display Small Square",
    width: 248,
    height: 248,
    actualWidth: 200,
    actualHeight: 200,
    desc: "The Google Display small square ad option at 200 × 200 pixels is both responsive and versatile. It can adjust to most sizes and help you reach even more potential users.",
  },
  {
    label: "Google Display Skyscraper",
    width: 248,
    height: 1240,
    actualWidth: 120,
    actualHeight: 600,
    desc: "Google Display Skyscraper sidebar ads size is 120 x 600 pixels. Grab attention and build brand engagement through Skyscraper sidebar ads. Make an impression with the right images and animations and increase your conversion rates.",
  },
  {
    label: "Google Display Vertical Rectangle",
    width: 248,
    height: 413,
    actualWidth: 240,
    actualHeight: 400,
    desc: "The Google Display Vertical rectangle, or 240 × 400 pixels, is popular in sidebars and alongside some key content story. Don’t forget to design the right color and image combination that your target audience can relate to.",
  },
  {
    label: "Google Display Medium Rectangle",
    width: 248,
    height: 207,
    actualWidth: 300,
    actualHeight: 250,
    desc: "Medium rectangle ads at 300 x 250 pixels look good on Google Display either embedded within text or at the end of articles. Of course, you’ll have to choose the right template and format to make your brand stand out.",
  },
  {
    label: "Google Display Inline Rectangle",
    width: 248,
    height: 207,
    actualWidth: 300,
    actualHeight: 250,
    desc: "The Google Display inline rectangle ads size are 300 x 250 pixels, which is great for placing within text or at the end of articles. Use our multimedia platform to make sure they stand out with the right colors for your brand.",
  },
  {
    label: "Google Display Half Banner",
    width: 248,
    height: 64,
    actualWidth: 234,
    actualHeight: 60,
    desc: "A Google Display half banner at 234 x 60 pixels can fit into smaller spaces but this means that it will also have to be that much more eye-catching. Get the right colors to stand out more.",
  },
  {
    label: "Google Display Netboard",
    width: 248,
    height: 171,
    actualWidth: 580,
    actualHeight: 400,
    desc: "With 580 x 400 pixels to play around with, you can create responsive Google Display netboard ads with any multimedia option. Create your unique blend of customized images, text and animations to boost brand awareness.",
  },
  {
    label: "Google Display Half-Page Ad",
    width: 248,
    height: 496,
    actualWidth: 300,
    actualHeight: 600,
    desc: "You can create some amazing ads with the Google Display half-page option sized at 300 x 600 pixels. They are versatile and can be as animated as much or as little as you want.",
  },
  {
    label: "Google Display Wide Skyscraper",
    width: 248,
    height: 930,
    actualWidth: 160,
    actualHeight: 600,
    desc: "With a 160 x 600 wide skyscraper Google Display ad you can make even more impact. Get the most exposure for your audience with the right visuals for your industry and more than one clickable image.",
  },
  {
    label: "Google Display Leaderboard",
    width: 248,
    height: 64,
    actualWidth: 728,
    actualHeight: 90,
    desc: "Customize your Google Display Leaderboard ad at 728 × 90 pixels Increase your traffic by building your unique links with several clickable images. These are in prime positions and can be optimized to grab attention.",
  },
  {
    label: "Google Display Mobile Banner",
    width: 248,
    height: 64,
    actualWidth: 300,
    actualHeight: 50,
    desc: "With 300 x 50 pixels of space, make sure you use optimized Google Display mobile banners. Visuals and photos of faces make more of an impression than text on the small screen. Colors and animations also usually appeal to people.",
  },
  {
    label: "Google Display Banner",
    width: 248,
    height: 64,
    actualWidth: 468,
    actualHeight: 68,
    desc: "Make sure it’s within 468 x 68 pixels and doesn’t blend into the background. Promote your business with appealing Google Display banners. Use the best combination of images, text and animations for your brand’s style and image.",
  },
  {
    label: "Google Display Triple Widescreen",
    width: 248,
    height: 180,
    actualWidth: 250,
    actualHeight: 360,
    desc: "The Google Display triple widescreen is 250 x 360 pixels in size and works well next to webpage sidebars. This size seems to work particularly well in European countries, for example, Sweden.",
  },
  {
    label: "Google Display Portrait",
    width: 248,
    height: 868,
    actualWidth: 300,
    actualHeight: 1050,
    desc: "With the larger size, 300 x 1050 pixels, of Google Display Portrait ads you can easily create a compelling story and call to action. Make it visually attracted and add pictures of people to connect emotionally to your audience.",
  },
  {
    label: "Google Display Large Leaderboard",
    width: 248,
    height: 64,
    actualWidth: 970,
    actualHeight: 90,
    desc: "Google Display large leaderboard ads size is 970 x 90 pixels. Large leaderboard ads are a powerful way to grab attention and encourage clicks. Design the right layout of links and clickable images to optimize for traffic.",
  },
  {
    label: "Google Display Large Rectangle",
    width: 248,
    height: 207,
    actualWidth: 336,
    actualHeight: 280,
    desc: "Google Display large rectangle ads at 336 x 280 pixels in size are popular because of the extra space they provide. You’ll get increased reactions from your audience by integrating visuals with punchy text.",
  },
];

export const snapchatSizes = [
  {
    label: "Snapchat Image Share",
    width: 248,
    height: 441,
    actualWidth: 1080,
    actualHeight: 1920,
    desc: "Adhere to 1080 x 1920 pixels. Give your younger target audience greater incentives to come to your brand with Snapchat image sharing for coupons and offers. Include emojis or fun filters and add short text since you can’t use captions.",
  },
];

export const youtubeSizes = [
  {
    label: "YouTube Profile Picture",
    width: 248,
    height: 248,
    actualWidth: 250,
    actualHeight: 250,
    desc: "A YouTube pfp should be a minimum of 250 x 250 pixels at minimum. Bigger YouTube profile picture sizes will instantly be reduced. The ideal YouTube profile picture or channel icon size is 800 x 800 pixels. Our pfp maker uses the latter for your YouTube pfp.",
  },
  {
    label: "YouTube Banner",
    width: 248,
    height: 140,
    actualWidth: 2560,
    actualHeight: 1440,
    desc: "Your YouTube banner background will show in various dimensions across different platforms. The recommended YouTube channel banner size is 2560 x 1440 pixels for all devices. Then, view your image on different devices and make adjustments based on platform.",
  },
  {
    label: "YouTube Thumbnail Size",
    width: 248,
    height: 140,
    actualWidth: 1280,
    actualHeight: 720,
    desc: "Enhance your own YouTube thumbnails by using the correct thumbnail size: 1280 x 720 pixels, with a bare minimum width of 640 pixels. A ratio of 16:9 is best as it's implemented most often in YouTube players and previews.",
  },
  {
    label: "YouTube Companion Banner",
    width: 248,
    height: 64,
    actualWidth: 300,
    actualHeight: 60,
    desc: "Companion banner ads specs: 300 x 60 pixels. A clickable thumbnail on a YouTube page that is found alongside the ad. A companion banner gives you ongoing brand presence once a video stops, and the audience can click on it at any time.",
  },
  {
    label: "YouTube Overlay Ads",
    width: 248,
    height: 64,
    actualWidth: 480,
    actualHeight: 60,
    desc: "Overlay ads should match the following specs: 480 × 60 pixels. Overlay ads are compact static pics that appear as an overlay towards the bottom of a clip. Clicking these ads will open the advertiser's landing page.",
  },
  {
    label: "YouTube Display Ads",
    width: 248,
    height: 207,
    actualWidth: 300,
    actualHeight: 250,
    desc: "Display ads show up to the right of a video. Ad dimensions are 300 x 250 pixels or 300 x 60 pixels. Display ads on YouTube are exclusively offered for desktop marketing.",
  },
];

export const youtubeChannelArtSizes = [
  {
    label: "YouTube Channel Art Tablet Banner",
    width: 248,
    height: 57,
    actualWidth: 1855,
    actualHeight: 423,
    desc: "Ideal size is 2560 x 1440 pixels or 1855 x 423 pixels if you want to stay in the safe zone for tablets. Enhance your audience experience by uploading your very own customized channel banner.",
  },
  {
    label: "YouTube Channel Art TV",
    width: 248,
    height: 140,
    actualWidth: 2560,
    actualHeight: 1440,
    desc: "Simply ensure it’s optimized at 2560 x 1440 pixels and works across all devices. Boost your YouTube channel with an eye-catching banner at the top of your page that instantly communicates your brand and style.",
  },
  {
    label: "YouTube Channel Art Mobile Banner",
    width: 248,
    height: 69,
    actualWidth: 1546,
    actualHeight: 423,
    desc: "Make sure you stay in your safe zone of 1546 x 423 pixels, even if some of your artwork lies outside side for wider screens. Personalize your YouTube channel with an awesome channel banner to pull in your audience.",
  },
  {
    label: "YouTube Channel Art Desktop Banner",
    width: 248,
    height: 64,
    actualWidth: 2560,
    actualHeight: 423,
    desc: "Ideal size is 2560 x 1440 pixels or 1855 x 423 pixels if you want to stay in the safe zone for tablets. Enhance your audience experience by uploading your very own customized channel banner.",
  },
];

export const websiteSizes = [
  {
    label: "Website Portrait Content",
    width: 248,
    height: 372,
    actualWidth: 1000,
    actualHeight: 1500,
    desc: "The sizing for portrait content is specified as 1000 x 1500 pixels. Within your site webpages, there'll be sections containing images, textual content, call to action buttons, and so on. Essentially, these include the sections where pics are a component within the content.",
  },
  {
    label: "Website Full Width",
    width: 248,
    height: 165,
    actualWidth: 2400,
    actualHeight: 1600,
    desc: "To ensure that your full width images look good across any device big or small the recommended size is 2400 x 1600 pixels. Note that devices have different ratio than the one you shoot and it is possible your images will be cropped when viewed on web",
  },
  {
    label: "Website Landscape Content",
    width: 248,
    height: 165,
    actualWidth: 1500,
    actualHeight: 1000,
    desc: "The pixel dimension of your images need to be at least 1024 pixels wide. Suggested landscape is 1500 x 1000 pixels.Supported aspect ratios: Anywhere between 1.91:1 and 4:5",
  },
];

export const emailSizes = [
  {
    label: "Email Blog Image",
    width: 248,
    height: 248,
    actualWidth: 750,
    actualHeight: 750,
    desc: "Wonderful images should help your blog posts stick out. The best image size for blog images is 750 x 750 pixels. If you do this, your visuals will continue to work well whenever your posts are shared on many social platforms.",
  },
  {
    label: "Email Blog Featured",
    width: 248,
    height: 124,
    actualWidth: 1200,
    actualHeight: 600,
    desc: "Our recommendation for blog featured email images is 1200 x 600 pixels. Blog featured images essentially rely on the kind of blog listing template you're working with. In fact, they are a clear and concise strategy for spreading information.",
  },
  {
    label: "Email Header Image",
    width: 248,
    height: 83,
    actualWidth: 600,
    actualHeight: 200,
    desc: "The best header image specs for email is where it counts. More often than not, it's looked over without a second thought. Header graphics should be between 600 pixels in width, with a proportional height of 200 pixels.",
  },
];

export const tiktokSizes = [
  {
    label: "TikTok In-Feed Ad Image",
    width: 248,
    height: 248,
    actualWidth: 1080,
    actualHeight: 1080,
    desc: "Opt for 1080 x 1080 pixels for optimal results. The best TikTok Ads practices will create content that fits the format of the platform. However, they'll also use high-quality images and videos that meet TikTok ad specs.",
  },
  {
    label: "TikTok PFP",
    width: 248,
    height: 248,
    actualWidth: 200,
    actualHeight: 200,
    desc: "To make sure your pfp for TikTok looks it's best, use our suggested dimensions of 200 x 200 pixels. With out TikTok pfp downloader, you get that perfect sized pic that gets follows!",
  },
  {
    label: "TikTok Square Video Ad",
    width: 248,
    height: 248,
    actualWidth: 1080,
    actualHeight: 1080,
    desc: "The best TikTok square video ad size is making video ads viewable, as well as engaging. The recommended video dimensions for square are 1080 x 1080 pixels. The minimum dimensions are 600 x 600 pixels.",
  },
  {
    label: "TikTok Vertical Video Ad",
    width: 248,
    height: 441,
    actualWidth: 1080,
    actualHeight: 1920,
    desc: "To get the best vertical ads, it is advised for your upload to be no more than 500 MB. TikTok video sizes are 1080 × 1920 pixels. TikTok is typically viewed on a smartphone, so vertical video is ideal.",
  },
  {
    label: "TikTok Horizontal Video Ad",
    width: 248,
    height: 140,
    actualWidth: 1920,
    actualHeight: 1080,
    desc: "It's important to realize that vertical videos work best on TikTok, but horizontal ones are also acceptable. The horizontal video ad dimensions are 1920 x 1080 pixels to ensure the best landscape quality.",
  },
];

export const pinterestSizes = [
  {
    label: "Pinterest Portrait Carousel",
    width: 248,
    height: 372,
    actualWidth: 1000,
    actualHeight: 1500,
    desc: "Simply remember two options: 1000 x 1500 pixels (2:3), or 1000 x 1000 pixels (1:1). A Pinterest portrait carousel of several images is an interactive way to engage with your audience and connect with them emotionally.",
  },
  {
    label: "Pinterest Vertical Pin",
    width: 248,
    height: 372,
    actualWidth: 1000,
    actualHeight: 1500,
    desc: "Remember that they’re displayed vertically and that your ideal size is 1000 x 1500 pixels. Build engagement through increased exposure by creating relevant and appealing content for your pins. Keywords and catchy images are great ways to do this.",
  },
  {
    label: "Pinterest PFP",
    width: 248,
    height: 248,
    actualWidth: 165,
    actualHeight: 165,
    desc: "When using the pfp maker, choose a logo or image that showcases your product. The ideal Pinterest pfp will be 165 x 165 pixels in size. Get the right Pinterest profile photo that represents you so that what you stand for is immediately recognizable.",
  },
  {
    label: "Pinterest Square Carousel",
    width: 248,
    height: 248,
    actualWidth: 1000,
    actualHeight: 1000,
    desc: "The ideal size is 1000 x 1000 pixels, and make sure that you design something specifically attractive for your target audience. A carousel pin is a powerful and fun way to showcase different aspects of your product or service.",
  },
  {
    label: "Pinterest Story Pins",
    width: 248,
    height: 441,
    actualWidth: 1080,
    actualHeight: 1920,
    desc: "You should stick to a size of 1080 x 1920 pixels, and your visuals can become much more dynamic. Share multiple images and words through one Pinterest story pin with up to 20 images, videos and text.",
  },
  {
    label: "Pinterest Board Display",
    width: 248,
    height: 140,
    actualWidth: 222,
    actualHeight: 150,
    desc: "Keep everything to 222 x 150 pixels and don’t forget that you can add copy to images to provide context. Make great Pinterest board displays with exciting pins that also show your logo.",
  },
];

export const facebookAdsSizes = [
  {
    label: "Facebook Ads Carousel Image",
    width: 248,
    height: 248,
    actualWidth: 1200,
    actualHeight: 1200,
    desc: "For Home Carousel Ads, the preferred image size is 1080 x 1080 pixels, max image size of 30MG, and aspect ratio: 1:1. Carousel ad Image guidelines include a bare minimum dimensional width and height of 600 pixels.",
  },
  {
    label: "Facebook Ads Image Ad",
    width: 248,
    height: 130,
    actualWidth: 1200,
    actualHeight: 628,
    desc: "The optimum Facebook image ad size is 1200 x 628 pixels with visuals rather than text. Motivate and engage your audience with powerful ads showing happy faces, fun colors, loveable pets or even something funny.",
  },
  {
    label: "Facebook Ads Audience Network",
    width: 248,
    height: 130,
    actualWidth: 1200,
    actualHeight: 628,
    desc: "Facebook Audience Network ad advisable graphic size is 1200 x 628 pixels. The specifications for minimum width and height is 600 pixels. Facebook Audience Network lets you have your ads suggested on tons of high-quality sites and apps.",
  },
  {
    label: "Facebook Ads Messenger Image Ad",
    width: 248,
    height: 130,
    actualWidth: 1200,
    actualHeight: 628,
    desc: "Photo dimensions are 1200 x 628 pixels. While the minimum width is 500 pixels. Facebook Messenger Story Image ads should leave 250 pixels at the top and bottom of the image to get the best Facebook Image size.",
  },
  {
    label: "Facebook Ads Audience Network Link",
    width: 248,
    height: 130,
    actualWidth: 398,
    actualHeight: 208,
    desc: "Audience Network Ad Image proportions are a minimum 398 x 208 pixels. It's also a good idea to work with the image size of 1200 x 628 pixels. With a link, the image aspect ratio is 1.9:1.",
  },
  {
    label: "Facebook Ads Story Ad",
    width: 248,
    height: 441,
    actualWidth: 1080,
    actualHeight: 1920,
    desc: "Facebook Stories occupy the entire phone screen so the most suitable proportions will be 1,080 x 1,920 pixels with an aspect ratio of 9:16.",
  },
];

export const sizesArray = [
  facebookSizes,
  instagramSizes,
  facebookAdsSizes,
  googleAdsSizes,
  pinterestSizes,
  tiktokSizes,
  snapchatSizes,
  websiteSizes,
  emailSizes,
  twitterSizes,
  linkedinSizes,
  youtubeChannelArtSizes,
  youtubeSizes,
];
